import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { StatusRank } from "components/atoms/LoyaltyRankStatus/types";
import LoyaltyRankStatus from "components/atoms/LoyaltyRankStatus";
import useTranslate from "hooks/useTranslate";
import LoyaltyCircleProgress from "components/atoms/LoyaltyCircleProgress";
import { RewardItemT } from "./types";
import { LOYALTY_REWARDS_KEYS } from "./constants";
import "./styles.sass";

type LoyaltyListRewardsProps = {
  title: string;
  rewards: RewardItemT[];
  status: StatusRank;
  isRank?: boolean;
  withProgress?: boolean;
  userExperience?: number;
  requirement?: number;
  nextRequirement?: number;
  isLast?: boolean;
};

// Никак не трогать компонент ! ОБращаться к Роме ес шо
const LoyaltyListRewards = (props: LoyaltyListRewardsProps) => {
  const {
    title,
    rewards,
    status,
    isRank,
    withProgress,
    userExperience,
    requirement,
    nextRequirement,
    isLast = false,
  } = props;
  const t = useTranslate();
  const refDiv = useRef<HTMLDivElement>(null);
  const [heightProgressBar, setHeightProgressBar] = useState<string>("100%");
  const variant =
    rewards.some((reward) => !reward.isClose) ||
    (!!userExperience &&
      requirement !== undefined &&
      userExperience >= requirement)
      ? "colored"
      : undefined;

  const calcHeightProgress = () => {
    if (userExperience && requirement !== undefined && nextRequirement) {
      if (isLast && userExperience >= requirement) {
        return "calc(100% + 20px)";
      }
      if (userExperience >= nextRequirement) {
        if (isLast) {
          return "calc(100% + 40px)";
        }
        return "100%";
      }

      if (userExperience < requirement) {
        return "0%";
      }

      const progress = nextRequirement - requirement;
      const userProgress = userExperience - requirement;
      const percentHeight = (userProgress / progress) * 100;

      return `${percentHeight}%`;
    }

    return "0%";
  };

  useEffect(() => {
    if (heightProgressBar === "100%" && refDiv.current) {
      setHeightProgressBar(
        `${refDiv.current!.getBoundingClientRect()!.height + 20}px`,
      );
    }
  }, [withProgress, heightProgressBar]);

  return (
    <div className="LoyaltyListRewards" ref={refDiv}>
      {!!withProgress && (
        <div
          className="LoyaltyListRewards__progressbar"
          style={{ height: heightProgressBar }}
        >
          <LoyaltyCircleProgress
            className="LoyaltyListRewards__circle"
            variant={variant}
          />
          <div
            className="LoyaltyListRewards__progress"
            style={{ height: calcHeightProgress() }}
          />
        </div>
      )}
      <div className="LoyaltyListRewards__title">
        <LoyaltyRankStatus status={status} />
        {isRank ? t("loyalty.rank.title-rewards") : t(title)}
      </div>
      <div className="LoyaltyListRewards__list">
        {rewards?.map((reward) => (
          <span
            key={`${title}-${reward.name}-${reward.value}`}
            className={classNames(
              "LoyaltyListRewards__listItem",
              reward.isClose && "LoyaltyListRewards__listItem_close",
            )}
          >
            {t(LOYALTY_REWARDS_KEYS[reward.name])} {reward.value}
          </span>
        ))}
      </div>
    </div>
  );
};

export default LoyaltyListRewards;
